module.exports = __webpack_public_path__ + "media/ww.264bd00b.mp3";